﻿import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { productApi } from '../api/services';
export default function ProductDetailPage() { const { id } = useParams(); return <div className='container' style={{paddingTop:'32px'}}><h1>Ürün Detayı</h1><p className='text-muted'>ID: {id}</p></div>; }
